import Common from './Common';

class Provider extends Common {
  constructor() {
    super('/api/v1/payments');
    this.getClientSecret = this.getClientSecret.bind(this);
    this.getById = this.getById.bind(this);
    this.update = this.update.bind(this);
  }

  getClientSecret() {
    return this.get();
  }

  getById(id) {
    return this.get(null, id);
  }

  update(id, data) {
    return this.save({ id, ...data });
  }
}

const provider = new Provider();

export const {
  getClientSecret,
  getById,
  update,
} = provider;



// WEBPACK FOOTER //
// ./src/services/providers/payments.js